module.exports = __webpack_public_path__ + "img/Mob_Slider1.3f327fa7.svg";